import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { IssueTransactionAudit } from '../../../classes';
import { IIssueAuditWrapperProvider, ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';

@Component({
  selector: 'app-issue-transaction-audit',
  templateUrl: './issue-transaction-audit.component.html',
  styleUrls: ['./issue-transaction-audit.component.css']
})
export class IssueTransactionAuditComponent implements OnDestroy, OnInit {

  private _audit = new ReplaySubject<IssueTransactionAudit[]>();
  @Input() set issueItemAuditStatus(audit: IssueTransactionAudit[]){
    this._audit.next(audit);
  }

  audit$ = this._audit.asObservable();

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) private _issueAuditWrapperProvider: IIssueAuditWrapperProvider
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueAuditWrapperProvider.issueAuditWrapper$.subscribe((wrapper) => this.issueItemAuditStatus = wrapper.issueTransactionAudit)
    ])
  }

}
